import React from 'react';
import { HR_TABS, HR_NAV_TABS } from '../utils/hrTabs';
import StartLockedDepartmentPage from '../components/start/StartLockedDepartmentPage';

/**
 * Locked preview of the portal HR hub (/portal/hr).
 *
 * Matches HRAllTab: no Goals card in the top row, and Hiring Status rather than
 * Implementation Hours on the right. No unlock map — none of the HR free-page
 * grants have a /start page behind them.
 */
const StartHR = () => (
  <StartLockedDepartmentPage
    title="Human Resources"
    tabs={HR_NAV_TABS}
    allTabs={HR_TABS}
    showGoals={false}
    rightCard="hiring"
  />
);

export default StartHR;
